var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountNumberHelpIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E7EEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 26V24.146H18.4135C21.6355 21.716 23.6695 19.736 23.6695 17.522C23.6695 15.128 21.6355 13.814 19.3135 13.814C17.6395 13.814 15.9475 14.462 14.8855 15.74L16.1095 17.126C16.8655 16.262 17.9455 15.686 19.3495 15.686C20.4475 15.686 21.5275 16.262 21.5275 17.522C21.5275 19.25 19.7095 20.816 15.0475 24.344V26H23.7415Z",
    fill: "#0092BD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNumberHelpIcon2);
export default __webpack_public_path__ + "static/media/AccountNumberHelpIcon2.462072f4fae987abfc41bf30ede07a27.svg";
export { ForwardRef as ReactComponent };